import { render, staticRenderFns } from "./Create-Assessment.vue?vue&type=template&id=6e009a39&scoped=true"
import script from "./Create-Assessment.vue?vue&type=script&lang=js"
export * from "./Create-Assessment.vue?vue&type=script&lang=js"
import style0 from "./Create-Assessment.vue?vue&type=style&index=0&id=6e009a39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e009a39",
  null
  
)

export default component.exports